import { render } from "./TextUsIcon.vue?vue&type=template&id=1d5a25da"
import script from "./TextUsIcon.vue?vue&type=script&lang=js"
export * from "./TextUsIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__